import React from 'react'
import { useNavigate } from 'react-router-dom'
import WTPDataUploadCard from './WTPDataUploadCard'

export default function WTPDataUploadCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName,DashProjectTypeId,WTPMasterCountData } = props

    const WTPWaterQualityDataUploadNavigate = (name, screenFlag) => {
        if (name === "Water Quality") {
            navigate(`/wtpwaterqualitydatauploadpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if(name === "Quantity of Water") {
            navigate(`/wtpquantityofwaterpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }
    const navigate = useNavigate()
    return (

        <div>
            <div className="row">
                <h5 className="ml-4 py-2">Data Upload</h5>
            </div>
            <div className="row pr-3 pl-3">

                <div className="col-12 col-md-6 col-lg-4 mb-2 ">
                    <WTPDataUploadCard
                        title="Water Quality"
                        imgPath='./assets/img/water-quality.png'
                        count={WTPMasterCountData?.WaterQualityTotalCount ? WTPMasterCountData?.WaterQualityTotalCount : '0'}
                    // count={Countdata?.WaterQualityPHTotalCount}
                    // navLink='/waterqualityphservicepage'
                    WTPWaterQualityDataUploadNavigate={WTPWaterQualityDataUploadNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <WTPDataUploadCard
                        title="Quantity of Water"
                        imgPath='./assets/img/waterquantity.png'
                        count={WTPMasterCountData?.QuantityofWaterTotalCount ? WTPMasterCountData?.QuantityofWaterTotalCount : '0'}
                    // count={Countdata?.WaterQualityChlorineTotalCount}
                    WTPWaterQualityDataUploadNavigate={WTPWaterQualityDataUploadNavigate}
                    />
                </div>

            </div>
        </div>

    )

}
